var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.canPersonalDataView || _vm.canPersonalDataEdit)?_c('PersonalData'):_vm._e(),(_vm.canPersonalDataView || _vm.canPersonalDataEdit)?_c('br'):_vm._e(),_c('Password')],1)}
var staticRenderFns = []

export { render, staticRenderFns }